import { render } from "./SSO.vue?vue&type=template&id=c53dfdfc"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"

import "./SSO.vue?vue&type=style&index=0&id=c53dfdfc&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__